import React, {useEffect, useRef, useState} from 'react';
import gsap from 'gsap';
import "./EnhancedPopUp.sass";
import renderHTML from 'react-render-html';
import Button from "../Button/Button";
import StandardButton from "../Button/StandardButton";

const EnhancedPopUp = ({data, onHide, onShow}) => {

        const [showing, setShowing] = useState(true);
        const popup = useRef(null);

        useEffect(() => {
            gsap.killTweensOf(".EnhancedPopUp");
            if (!showing) {
                gsap.fromTo(".EnhancedPopUp", 1, {opacity: 1}, {opacity: 0, onComplete: onHideComplete})
            } else {
                gsap.fromTo(".EnhancedPopUp", 1, {opacity: 0}, {opacity: 1, onComplete: onShowComplete})
            }
        }, [showing]);

        const onHideComplete = () => {
            if (onHide) {
                onHide();
            }
        }

        const onShowComplete = () => {
            if (onShow) {
                onShow();
            }
        }

        const hide = () => {
            setShowing(showing ? false : true);
        }

        return (
            <div className="EnhancedPopUp"
                 style={data.bg ? {"backgroundImage": "url(" + data.bg + ")"} : {}}
                 ref={popup}>
                {(data && data.textbox) &&
                <div className={data.className || "popup-panel"}
                     style={(data.textbox.style ? data.textbox.style : {})}>
                    {data.textbox.title &&
                    <div className="popup-panel-title">
                        {data.textbox.title}</div>}
                    {(data.textbox.body && data.textbox.title) &&
                    <div className="popup-divider"/>
                    }
                    {(data.textbox.body) && <div className="popup-panel-body">
                        {renderHTML(data.textbox.body)}
                    </div>}
                    <StandardButton data={"CONTINUE"}
                            callback={hide}/>
                </div>}
                <div className={"scrim"+(data.bg?" invisible":"")}/>
            </div>
        );
    }
;

export default EnhancedPopUp;